import Btn from '../utils/btn';

const func = $target => {
    var $btn = new Btn($target.find('button[type="submit"]'));

    $('.chooseFile').click(function () {
        $(this).parent().find('#triggerType').click();
    })

    $(".form-control-file").change(function () {
        var input = this,
            $this = $(this),
            $name = $(this).attr('name'),
            totalSize = 0;

        if (input.files && input.files[0]) {
            var reader = new FileReader();
            $(this).parent().find('.text-up-lower').text(this.files[0].name)
            reader.onload = function (e) {
                console.log(e.target, '----e.target')
                // $this.closest('.card').find('.static-img').addClass('d-none');
                $this.closest('.card').find('.uploaded-img').removeClass('d-none');
                $this.closest('.card').find('[data-id="image-preview"]').attr('src', e.target.result).height(144).removeClass('d-none');
                // $this.closest('.card').find('.custom-checkbox').remove()
            }

            reader.readAsDataURL(input.files[0]); // convert to base64 string
        }

        if ($name === 'file-final-desired-shade'){
            $target.find('.final-desired-error').css('display','none')
        }
        if ($name === 'file-intra-oral' || $name === 'file-ply-lower' || $name === 'file-ply-upper'){
            $target.find('.ply-intra-oral-error').css('display','none')
        }
        $(".form-control-file").each(function () {
            for (var i = 0; i < this.files.length; i++) {
                totalSize += this.files[i].size;
            }
        });

        console.log(totalSize);

        var valid = totalSize <= 262144000; //250mb limit

        if (!valid) {
            console.log('too big');
            $target.find('[data-id="upload-error-message"]').removeClass('d-none');
            $btn.disable();
        } else {
            $target.find('[data-id="upload-error-message"]').addClass('d-none');
            $btn.enable();
        }
    });
    $target.on('submit', function (e) {

        $('.input-text').each(function () {
            if ($(this).val() == ''){
                $(this).attr('required',true)
            }
        })
        if ($('.final-desired')[0].files.length == 0){
            $(this).attr('required',true)
            $target.find('.final-desired-error').css('display','block')
        }
        let count = 0;
        let up_lower_count = 0;

        if ($('.intra-oral')[0].files.length > 0){
            $('.up-lower').attr('required',false)
            count++;
        }else {
            $('.up-lower').each(function () {
                if (this.files.length > 0){
                    up_lower_count++;
                }
            })
        }
        if (up_lower_count == 2){
            $('.intra-oral').attr('required',false)
            count++
        }
        if (count == 0){
            $target.find('.ply-intra-oral-error').css('display','block')
            $btn.processed()
            return false
        }
    });
}

export default func;